var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarmProfileWhite = function SvgAlarmProfileWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.857 27.082a23.9 23.9 0 0 0 5.454-1.31A8.97 8.97 0 0 1 34 19.75V19a6 6 0 0 0-12 0v.75a8.97 8.97 0 0 1-2.311 6.022c1.732.64 3.56 1.085 5.454 1.31m5.714 0a24.3 24.3 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 36,
    x: 14,
    y: 4,
    stroke: "#E6F1F2",
    strokeWidth: 3,
    rx: 1.688
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeWidth: 3,
    d: "m35 40-18.154 5.069a1.687 1.687 0 0 1-2.084-1.189l-8.467-31.6a1.69 1.69 0 0 1 1.088-2.034L14 8"
  })));
};
export { SvgAlarmProfileWhite as ReactComponent };
export default __webpack_public_path__ + "2a062ad5b8b32540aa8e0e1d2095d048.svg";